import { createGlobalStyle } from "styled-components";

export const AskQuestionCss = createGlobalStyle`
    .parent-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 80%;
        gap: 7px;
    }
    .parent-container input {

    }
    .success-msg {
        color: green;
        font-size: 22px;
    }
`;
